<template>
  <div>
    <v-divider></v-divider>

    <h3 class="my-5 text-center">
      Invitation History ({{ invitations.length }})
    </h3>

    <ManuscriptInvitation
      v-for="(invitation, index) in invitations"
      :invitation="invitation"
      :key="invitation._id"
      :class="index != 0 ? 'mt-3' : ''"
    />
  </div>
</template>

<script>
import ManuscriptInvitation from "../../Review/Includes/ManuscriptInvitation";

export default {
  props: {
    manuscript: {
      type: Array,
      default: () => {},
    },
    invitations: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ManuscriptInvitation,
  },
};
</script>

<style>
</style>